var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4913 1.8335C5.66125 1.8335 1.75 5.94016 1.75 11.0002C1.75 16.0602 5.66125 20.1668 10.4913 20.1668C15.33 20.1668 19.25 16.0602 19.25 11.0002C19.25 5.94016 15.33 1.8335 10.4913 1.8335ZM14.2188 14.8043L9.625 11.9168V6.41683H10.9375V11.2293L14.875 13.6768L14.2188 14.8043Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationCreate);
export default __webpack_public_path__ + "static/media/ReservationCreate.3188a9c9fb836dcd2fa142c4345ecb10.svg";
export { ForwardRef as ReactComponent };